import type { NavigationItem } from '@hetivo/hetivo-lib-web-utils';

import { INSPECTIONS_PATH } from '../paths';

/**
 * Sets the Due-inspection count on the sidebar's Inspections item (SWOOP-400). Returns a new array so the input
 * is never mutated; every other item is passed through unchanged. A `count` of `undefined` (not entitled, no
 * permission, not yet loaded or failed) leaves the item without a badge. The sidebar itself hides a 0 and caps
 * the pill at 99+.
 */
export function applyInspectionsBadge(
  items: NavigationItem[],
  count: number | undefined,
  label: string,
): NavigationItem[] {
  if (count === undefined) {
    return items;
  }
  return items.map((item) =>
    item.path === INSPECTIONS_PATH ? { ...item, badgeCount: count, badgeCountLabel: label } : item,
  );
}
